import React, { ReactElement } from 'react';
import withChartWrapper from '../withChartWrapper';
import {
  buildEvolutionChart,
  type EvolutionServerData,
} from './portfolioLiquidation.data';
import { mainColors } from '../../../../../../styling/theme';
import GenericLineChart from '../../../../../charts/GenericLineChart';
import { GridProps } from '@mui/material';

export interface Dimensions {
  dimensions: GridProps;
}

interface Props extends Dimensions {
  evolutionPayload: EvolutionServerData | undefined;
  isFetching: boolean;
  error?: unknown;
  height: number;
}

function PortfolioLiquidation({
  evolutionPayload,
  isFetching,
  error,
  height,
}: Props): ReactElement {
  const chartData = buildEvolutionChart(evolutionPayload, 'q1');
  return (
    <>
      <GenericLineChart
        error={error}
        export
        download
        loading={isFetching}
        width="90%"
        margin={{ top: 10, left: 0, right: 30, bottom: 10 }}
        height={height}
        title="Portfolio Liquidation Time"
        showTitle
        data={chartData}
        legendFormatter={(value: any, entry: any) => {
          const { color } = entry;
          let name;
          if (value === 'bau') {
            name = 'BAU';
          } else if (value === 'stressed') {
            name = 'Stressed';
          } else {
            name = 'Super Stressed';
          }

          return <span style={{ color }}>{name}</span>;
        }}
        yAxisLabel={{ value: 'Days', angle: -90, position: 'insideLeft' }}
        yAxisDomain={[0, (dataMax: number) => dataMax * 1.1]}
        showLegend
        lines={[
          {
            dataKey: 'bau',
            color: mainColors.mainBlue,
            yAxisId: 'left',
          },
          {
            dataKey: 'stressed',
            color: mainColors.Alert,
            yAxisId: 'left',
          },
          {
            dataKey: 'superStressed',
            color: mainColors.secondaryRed,
            yAxisId: 'left',
          },
        ]}
      />
    </>
  );
}

export default withChartWrapper(PortfolioLiquidation);
